import { useEffect } from "react";
import Contact from "../components/Contact";
import Navigation from "../components/Navigation";
import useTitle from "@nooks/use-title";
import Reviewtable from "components/Reviewtable";

function ReviewCreate({userObj, isLoggedIn}){
    useTitle("캐리빌리 리뷰 작성")
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])
    return (
        <div>
            <Navigation userObj={userObj} isLoggedIn={isLoggedIn} />
            <div style={{marginTop: "3rem"}}></div>
            <Reviewtable userObj={userObj} />
            <Contact />
        </div>
    )
}

export default ReviewCreate;